"use strict";

var _defineProperty = require("/home/alfredo/Workspace/CarnesValidadas/Plataforma/v1/cv-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var serialized = "$$ babel internal serialized type" + Math.random();

function serialize(key, value) {
  var _ref;

  if (typeof value !== "bigint") return value;
  return _ref = {}, _defineProperty(_ref, serialized, "BigInt"), _defineProperty(_ref, "value", value.toString()), _ref;
}

function revive(key, value) {
  if (!value || typeof value !== "object") return value;
  if (value[serialized] !== "BigInt") return value;
  return BigInt(value.value);
}

function _default(value) {
  return JSON.parse(JSON.stringify(value, serialize), revive);
}